import headerTextImg from '../content/header/header_text.png';
import { getFailDeliveryHeaderBackgroundUrl } from './failDeliveryHeaderAssets';
import './FailDeliveryHeader.css';

/** From Figma title_bad (142:17540) + «ДостаВКа Провалена» (142:17542). */
export function FailDeliveryHeader() {
  return (
    <>
      <img
        className="fail-delivery-header__background"
        src={getFailDeliveryHeaderBackgroundUrl()}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="fail-delivery-header__text"
        src={headerTextImg}
        alt="Доставка провалена"
        draggable={false}
      />
    </>
  );
}
